(ns risk-profile.views
  (:require
    [reagent.core :as r]
    [very.re-frame.core :as rf]
    [css.core :refer [defstyled get-theme]]
    [css.form :as form]
    [css.vars :as vars]
    [cljss.core :as cljss]
    [client-onboard.common :as coc]
    [main.common :as common]
    [util.core :refer [safe-merge]]))

(defstyled location-wrapper-s :div
  {:display (with-meta #(if % "none" "flex") :hide?)
   :flex-direction "row"
   :justify-content "center"
   :max-width "740px"
   :margin "2.5rem auto 4rem"
   :align-items "center"})

(defstyled location-marker-inactive-s :div
  {:width "14.28%"
   :height "4px"
   :background "#bdbdbd"})

(defstyled location-marker-active-s :div
  {:width "14.28%"
   :height "4px"
   :background (get-theme :primary)})

(defstyled radio-group-s :div
  {:display "grid"
   :grid-gap "30px"
   :grid-template-columns (with-meta #(str "repeat(" % ", 1fr)") :columns)
   :margin "auto"
   :max-width (with-meta #(str (+ (* (- % 1) 30) (* 270 %)) "px") :columns)
   ::cljss/media {[[:max-width "900px"]]
                  {:grid-template-columns "1fr 1fr 1fr"}
                  [[:max-width "600px"]]
                  {:grid-template-columns "1fr 1fr"}}})

(defstyled radio-group-simple-s :div
  {:display "flex"
   :align-items "center"
   :justify-content "center"
   :width "100%"})

(defstyled radio-label-s :label
  {:background-image (with-meta #(str "url(/assets/icons/" % ".svg)") :image)
   :background-repeat "no-repeat"
   :background-size (with-meta #(or % "56px") :bg-size)
   :background-position (with-meta #(or % "center bottom 35px") :bg-pos)
   :height (with-meta #(or % "280px") :height)
   :max-width "270px"
   :box-shadow "0px 3px 12px 0px rgba(168, 166, 168, 0.72)"
   :transition "border 300ms ease-in"
   :border (with-meta #(if % (str "3px solid " (get-theme :primary)) "3px solid transparent") :selected?)
   :cursor "pointer"
   :position "relative"
   :line-height "24px"
   :font-size "20px"
   :padding "35px 20px 0"
   :color (get-theme :primary)
   :text-align "center"
   :&:hover {:border-color (get-theme :primary)}
   ::cljss/media {[[:max-width "768px"]]
                  {:padding "20px 5px 0"}}})

(defstyled radio-label-simple-s :label
  {:color "#282828"
   :font-size "20px"
   :margin-right "30px"
   :position "relative"
   :display "flex"
   :align-items "center"
   :cursor "pointer"
   :padding-left "25px"
   :&:last-child {:margin-right "0"}
   :&:before {:display "block"
              :position "absolute"
              :left "0"
              :top "0"
              :bottom "0"
              :margin "auto"
              :content ""
              :border (str "2px solid " (get-theme :primary))
              :border-radius "100%"
              :height "16px"
              :width "16px"}
   :&:after {:display (with-meta #(if % "block" "none") :selected?)
             :width "12px"
             :height "12px"
             :position "absolute"
             :left "4px"
             :top "4px"
             :bottom "0"
             :border-radius "100%"
             :content ""
             :background (get-theme :primary)}})

(defstyled label-top-s :div
  {})

(defstyled label-bottom-s :div
  {:position "absolute"
   :bottom "35px"
   :right "0"
   :left "0"
   :text-align "center"})

(defstyled radio-field-s :input
  {:display "none"})

(defn radio-field [{:keys [name value on-change default-value]}]
  [radio-field-s {:type "radio"
                  :name name
                  :value value
                  :checked (= value default-value)
                  :on-change #(on-change name (.. % -target -value))}])

(defn radio-group [{:keys [fields name on-change default-value columns height bg-size bg-pos] :as data}]
  [radio-group-s
   {:columns columns}
   (map
     (fn [f]
       [radio-label-s {:image (:image f)
                       :selected? (= (:value f) default-value)
                       :key (:value f)
                       :height height
                       :bg-size bg-size
                       :bg-pos bg-pos}
        [radio-field {:name name
                      :value (:value f)
                      :on-change on-change
                      :default-value default-value}]
        (or (:label f) (:value f))])
     fields)])

(defn radio-group-simple [{:keys [fields name on-change default-value] :as data}]
  [radio-group-simple-s
   (map
     (fn [f]
       [radio-label-simple-s {:selected? (= (:value f) default-value)
                              :key (:value f)}
        [radio-field {:name name
                      :value (:value f)
                      :on-change on-change
                      :default-value default-value}]
        (or (:label f) (:value f))])
     fields)])

(defn form-step-growth [{:keys [on-change growth change-page cancel cancel-label]}]
  [:div
   [radio-group {:name :growth
                 :columns 5
                 :height "290px"
                 :bg-size "56px auto"
                 :on-change on-change
                 :default-value growth
                 :fields [{:value "0-2%"
                           :image "growth-1"}
                          {:value "2-4%"
                           :image "growth-2"}
                          {:value "4-6%"
                           :image "growth-3"}
                          {:value "6-8%"
                           :image "growth-4"}
                          {:value "More than 8%"
                           :image "growth-5"}]}]
   [form/button-row-s
    [form/secondary-button-s {:on-click cancel
                              :type "button"} cancel-label]
    [form/button {:type "button" :on-click #(change-page 1)} "Next"]]])

(defn form-step-concerns [{:keys [on-change concerns change-page]}]
  [:div
   [radio-group {:name :concerns
                 :value "0-2%"
                 :columns 3
                 :height "340px"
                 :bg-size "140px auto"
                 :on-change on-change
                 :default-value concerns
                 :fields [{:value "Most concerned about my investment losing value."
                           :image "concerns-1"}
                          {:value "Equally concerned about my investment losing or gaining value."
                           :image "concerns-2"}
                          {:value "Most concerned about my investment gaining value."
                           :image "concerns-3"}]}]

   [form/button-row-s
    [form/secondary-button-s {:type "button" :on-click #(change-page 0)} "Previous"]
    [form/button {:type "button" :on-click #(change-page 2)} "Next"]]])

(defn form-step-knowledge [{:keys [on-change knowledge change-page]}]
  [:div
   [radio-group {:name :knowledge
                 :value "0-2%"
                 :columns 4
                 :height "320px"
                 :bg-size "150px auto"
                 :on-change on-change
                 :default-value knowledge
                 :fields [{:value "Minimal"
                           :image "knowledge-1"}
                          {:value "Limited"
                           :image "knowledge-2"}
                          {:value "Good"
                           :image "knowledge-3"}
                          {:value "Extensive"
                           :image "knowledge-4"}]}]
   [form/button-row-s
    [form/secondary-button-s {:type "button" :on-click #(change-page 1)} "Previous"]
    [form/button {:type "button" :on-click #(change-page 3)} "Next"]]])

(defn form-step-tradeoff [{:keys [on-change tradeoff change-page]}]
  [:div
   [radio-group {:name :tradeoff
                 :value "0-2%"
                 :columns 5
                 :bg-size "95px auto"
                 :bg-pos "center"
                 :on-change on-change
                 :default-value tradeoff
                 :fields [{:value "+$2,000 / $0"
                           :label [:div
                                   [label-top-s "+$2,000"]
                                   [label-bottom-s"$0"]]
                           :image "tradeoff-1"}
                          {:value "+$9,000 / -$5,000"
                           :label [:div
                                   [label-top-s "+$9,000"]
                                   [label-bottom-s "-$5,000"]]
                           :image "tradeoff-2"}
                          {:value "+$20,000 / -$13,000"
                           :label [:div
                                   [label-top-s "+$20,000"]
                                   [label-bottom-s "-$13,000"]]
                           :image "tradeoff-3"}
                          {:value "+$31,000 / -$21,000"
                           :label [:div
                                   [label-top-s "+$31,000"]
                                   [label-bottom-s "-$21,000"]]
                           :image "tradeoff-4"}
                          {:value "+$37,000 / -$26,000"
                           :label [:div
                                   [label-top-s "+$37,000"]
                                   [label-bottom-s "-$26,000"]]
                           :image "tradeoff-5"}]}]
   [form/button-row-s
    [form/secondary-button-s {:type "button" :on-click #(change-page 2)} "Previous"]
    [form/button {:type "button" :on-click #(change-page 4)} "Next"]]])

(defn form-step-loss-anxiety [{:keys [on-change loss-anxiety change-page]}]
  [:div
   [radio-group {:name :loss-anxiety
                 :value "0-2%"
                 :columns 5
                 :bg-size "115px auto"
                 :on-change on-change
                 :default-value loss-anxiety
                 :fields [{:value "$1,000"
                           :image "anxiety-1"}
                          {:value "$10,000"
                           :image "anxiety-2"}
                          {:value "$15,000"
                           :image "anxiety-3"}
                          {:value "$25,000+"
                           :image "anxiety-4"}
                          {:value "$50,000+"
                           :image "anxiety-5"}]}]
   [form/button-row-s
    [form/secondary-button-s {:type "button" :on-click #(change-page 3)} "Previous"]
    [form/button {:type "button" :on-click #(change-page 5)} "Next"]]])

(defn form-step-timeframe [{:keys [on-change timeframe change-page]}]
  [:div
   [radio-group {:name :timeframe
                 :value "0-2%"
                 :columns 6
                 :bg-size "95px auto"
                 :on-change on-change
                 :default-value timeframe
                 :fields [{:value "1 year or less"
                           :image "timeframe-1"}
                          {:value "1 – 2 years"
                           :image "timeframe-2"}
                          {:value "3 – 5 years"
                           :image "timeframe-3"}
                          {:value "6 – 10 years"
                           :image "timeframe-4"}
                          {:value "11 – 15 years"
                           :image "timeframe-5"}
                          {:value "More than 15 years"
                           :image "timeframe-6"}]}]
   [form/button-row-s
    [form/secondary-button-s {:type "button" :on-click #(change-page 4)} "Previous"]
    [form/button {:type "button" :on-click #(change-page 6)} "Next"]]])

(defn form-step-expenses [{:keys [on-change expenses change-page]}]
  [:div
   [radio-group-simple {:name :expenses
                        :value "0-2%"
                        :on-change on-change
                        :default-value expenses
                        :fields [{:value "Yes"}
                                 {:value "No"}]}]
   [form/button-row-s
    [form/secondary-button-s {:type "button" :on-click #(change-page 5)} "Previous"]
    [form/button {:type "submit"} "Done"]]])

(defn default-form-values [values]
  (safe-merge {:growth "4-6%"
               :concerns "Equally concerned about my investment losing or gaining value."
               :knowledge "Good"
               :tradeoff "+$31,000 / -$21,000"
               :loss-anxiety "$25,000+"
               :timeframe "6 – 10 years"
               :expenses "No"}
              values))

(def risk->summary {"Conservative" "Based on the results of your survey, a Conservative portfolio may be best for your personalized allocation. A Conservative portfolio seeks income preservation over capital appreciation with a risk tolerance that typically ranges from low to moderate. Those who have shorter investment time horizons often fall into the Conservative category. This type of investor isn’t willing to tolerate large downside market fluctuations and is willing to forego significant upside potential to achieve their investment objectives."
                    "Conservative with Income" "Based on the results of your survey, a Conservative with Income portfolio may be best for your personalized allocation. A Conservative with Income portfolio seeks a steady income stream while also preserving capital. Risk tolerance typically ranges from low to moderate. Those who have shorter investment time horizons and seek an income stream often fall into the Conservative with Income category. This type of investor isn’t willing to tolerate large downside market fluctuations and is willing to forego significant upside potential to achieve their investment objectives."
                    "Moderate" "Based on the results of your survey, a Moderate portfolio may be best for your personalized allocation. A Moderate portfolio takes on more risk than a Conservative portfolio but less than a Growth portfolio. Moderate portfolios are comprised of investment strategies that seek returns by accepting a fair amount of risk without losing a significant amount of accumulated wealth. Those with longer investment time horizons typically fall into the Moderate category."
                    "Moderate with Income" "Based on the results of your survey, a Moderate with Income portfolio may be best for your personalized allocation. A Moderate with Income portfolio seeks a steady income stream while taking on more risk than a Conservative portfolio but less than a Growth portfolio. Moderate portfolios are comprised of investment strategies that seek returns by accepting a fair amount of risk without losing a significant amount of accumulated wealth. Those with longer investment time horizons and seek an income stream typically fall into the Moderate with Income category."
                    "Growth" "Based on the results of your survey, a Growth portfolio may be best for your personalized allocation. A Growth portfolio seeks to outperform the markets and has a higher risk tolerance. Growth portfolios are best for those with long investment time horizons and are comfortable assuming greater risk for potential higher returns."
                    "Growth with Income" "Based on the results of your survey, a Growth with Income portfolio may be best for your personalized allocation. A Growth with Income portfolio seeks a steady income steam with the objective to outperform the markets. Investors focused on portfolio Growth have a higher risk tolerance. Growth portfolios are best for those with long investment time horizons and are comfortable assuming greater risk for potential higher returns."})

(defn- risk-profile-type [score expenses]
  (let [with-income #(when (= % "Yes") " with Income")]
   (cond
        (<= score 10) (str "Conservative" (with-income expenses))
        (and (> score 10) (<= score 20)) (str "Moderate" (with-income expenses))
        (> score 20) (str "Growth" (with-income expenses)))))

(defstyled risk-type-s :div
  {:font-size (with-meta #(if % "2.27rem" "1.3rem") :large?)
   :color (get-theme :primary)
   :margin-bottom (with-meta #(if % "2rem" ".5rem") :large?)
   :font-weight (with-meta #(if % "300" "bold") :large?)})

(defstyled risk-text-s :p
  {:color "#666666"
   :line-height "1.6rem"
   :margin-bottom "1rem"})

(defn progress [step]
  [:div
   [common/form-subtitle-s "Discover the right investment strategy for you."]
   [location-wrapper-s
    (for [x (range step)]
      [location-marker-active-s {:key (str "lma" x)}])
    (for [y (range (- 7 step))]
      [location-marker-inactive-s {:key (str "lmi" y)}])]])

(def step->instruction {0 "How much do you expect your portfolio to grow annually over the long-term (10+ years)?"
                        1 "When I invest money I am:"
                        2 "I would describe my knowledge of investments as:"
                        3 "This chart shows the potential 1-year risk/return tradeoff of a $100k investment. Which would you choose?"
                        4 "What amount of loss in your portfolio would make you anxious assuming you start with $100,000?"
                        5 "I plan to begin taking money from my investments in..."
                        6 "Will you be looking for your investments to cover living expenses immediately?"})

(defn instructions [step]
  [common/form-title-s {:margin "0 0 4rem"} (get step->instruction step)])

(defn risk-profile-summary-text [{:keys [score expenses]} large?]
  (let [type (risk-profile-type score expenses)]
    [:div
     [risk-type-s {:large? large?} "Recommended: " type]
     [risk-text-s (get risk->summary type)]]))

(defn risk-survey-form [values {:keys [on-submit
                                       on-cancel
                                       on-step-change
                                       cancel-label]
                                :or {on-step-change #()
                                     cancel-label "Cancel"}}]
  (let [form-page (r/atom 0)
        form-values (r/atom (default-form-values values))
        change-page #(do
                       (reset! form-page %)
                       (on-step-change %))]
    (fn []
      [common/form-page-s
       [common/form-s
        {:on-submit (fn [e]
                      (.preventDefault e)
                      (on-submit @form-values))
         :max-width "1100px"}
        (condp = @form-page
          0
          [:div
           [instructions 0]
           [form-step-growth {:on-change #(swap! form-values assoc % %2)
                              :cancel on-cancel
                              :change-page change-page
                              :cancel-label cancel-label
                              :growth (:growth @form-values)}]]

          1
          [:div
           [instructions 1]
           [form-step-concerns {:on-change #(swap! form-values assoc % %2)
                                :change-page change-page
                                :concerns (:concerns @form-values)}]]

          2
          [:div
           [instructions 2]
           [form-step-knowledge {:on-change #(swap! form-values assoc % %2)
                                 :change-page change-page
                                 :knowledge (:knowledge @form-values)}]]

          3
          [:div
           [instructions 3]
           [form-step-tradeoff {:on-change #(swap! form-values assoc % %2)
                                :change-page change-page
                                :tradeoff (:tradeoff @form-values)}]]

          4
          [:div
           [instructions 4]
           [form-step-loss-anxiety {:on-change #(swap! form-values assoc % %2)
                                    :change-page change-page
                                    :loss-anxiety (:loss-anxiety @form-values)}]]

          5
          [:div
           [instructions 5]
           [form-step-timeframe {:on-change #(swap! form-values assoc % %2)
                                 :change-page change-page
                                 :timeframe (:timeframe @form-values)}]]

          6
          [:div
           [instructions 6]
           [form-step-expenses {:on-change #(swap! form-values assoc % %2)
                                :change-page change-page
                                :expenses (:expenses @form-values)}]])]])))
